/** Field-level context help for the invite create / edit form (see FieldHelp). */
import type { FieldHelpEntry } from '@/components/FieldHelp';

export const INVITE_HELP = {
  email: {
    title: 'Bound or unbound',
    body: 'With an e-mail the link is bound: the admin e-mail is fixed to it and the console can e-mail the link. Without one it is unbound — for QR codes on paper — and the client confirms the e-mail they type with an e-mailed code.',
    story: 'onboarding-invites',
  },
  quantity: {
    title: 'Quantity',
    body: 'Pre-issue up to 100 unbound links in one go; they share a batch id and print on one QR sheet. A bound link is created alone.',
    story: 'onboarding-invites',
  },
  restechs: {
    title: 'Allowed booking systems',
    body: 'Only these booking systems are offered to the client and accepted by the signup. Leave it empty to offer every booking system the self-signup supports.',
    story: 'onboarding-invites',
  },
  allowCodeEdit: {
    title: 'Tenant code',
    body: 'By default the tenant code is derived from the company and shown read-only. Tick this to let the client change it on their confirm card.',
    story: 'onboarding-invites',
  },
  advanced: {
    title: 'Advanced context',
    body: 'Any other JSON keys to keep with the invite; they are copied to the tenant when it is created. Known keys are checked here; any other key is kept as it is and flagged “not interpreted” — nothing reads it yet.',
    story: 'onboarding-invites',
  },
} satisfies Record<string, FieldHelpEntry>;
